import { useCallback, useState } from 'react';
import { fetchUserById } from '../../users/api/usersApi';

const extractUser = (data) =>
  data?.user || data?.data?.user || data?.data || data || null;

// Drzi stanje modala za obrazac za postu. Stranice koje imaju ceo objekat
// pacijenta koriste openForUser, a tabele koje imaju samo id - openForUserId.
const usePostalForm = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const openForUser = useCallback((userData) => {
    setUser(userData || null);
    setError(userData ? '' : 'Podaci o pacijentu nisu dostupni.');
    setLoading(false);
    setIsOpen(true);
  }, []);

  const openForUserId = useCallback(async (userId) => {
    setUser(null);
    setError('');
    setIsOpen(true);

    if (!userId) {
      setError(
        'Pacijent nije povezan sa ovim redom, pa obrazac ne može da se popuni.'
      );
      setLoading(false);
      return;
    }

    setLoading(true);
    const { data, ok, message } = await fetchUserById(userId);
    const userData = extractUser(data);

    if (!ok || !userData) {
      setError(message || 'Greška pri učitavanju podataka o pacijentu.');
      setLoading(false);
      return;
    }

    setUser(userData);
    setLoading(false);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    setUser(null);
    setError('');
    setLoading(false);
  }, []);

  return { isOpen, user, loading, error, openForUser, openForUserId, close };
};

export default usePostalForm;
